// VolumeReport.js
import React, { Component } from 'react';
import ReactTable from "react-table";
import { CSVLink } from "react-csv";
import Modal from 'react-modal';
import 'react-table/react-table.css';
import 'react-dropdown/style.css';
import DateTimePicker from 'react-datetime-picker';
import moment from 'moment';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '400px',
    color: 'black'
  },
  overlay: { zIndex: 1000 }
};

class VolumeReport extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    this.state = {
      volumeitems: [],
      cl_id: typeof(localStorage.getItem('headerClientId')) === 'undefined' ? 0 : localStorage.getItem('headerClientId'),
      startDate: new Date(today.getFullYear(), today.getMonth(), 1),
      endDate: new Date(today.getFullYear(), today.getMonth() + 1, 0),
      userToken: localStorage.getItem('userToken'),
      modalIsOpen: false,
      modalMessage: '',
      sortOptions: [{ id: 'pr_id', desc: true }]
    };
  }

  openModal = () => {
    if (!this.state.cl_id) {
      this.setState({ modalIsOpen: true, modalMessage: 'Please select a client first.' });
    }
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  }

  filterVolumeReport = () => {
    this.getVolumeReport(process.env.REACT_APP_NODE_ROOT_URL + '/reports/volume/' + this.state.cl_id);
  }

  getVolumeReport = (url) => {
    const { cl_id, startDate, endDate, userToken } = this.state;
    const payload = {
      cl_id,
      start_date: moment(startDate).format("YYYY-MM-DD"),
      end_date: moment(endDate).format("YYYY-MM-DD")
    };

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'bwToken': userToken
      },
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(volumeitems => this.setState({ volumeitems }))
      .catch(err => console.error('Volume report fetch error:', err));
  }

  componentDidMount() {
    Modal.setAppElement('#main');
  }

  render() {
    const { volumeitems, startDate, endDate, modalIsOpen, modalMessage, sortOptions } = this.state;

    return (
      <div id="main">
        <div className="page-wrapper">
          <div className="row page-titles">
            <div className="col-md-11 align-self-center">
              <h3 className="text-primary">Product Volume Report</h3>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <p>Select a Start and End Date for the report to see results.</p>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        Start Date:<br />
                        <DateTimePicker
                          disableClock
                          onChange={start => this.setState({ startDate: start })}
                          value={startDate}
                          format="MM-dd-y"
                        />
                      </td>
                      <td>
                        End Date:<br />
                        <DateTimePicker
                          disableClock
                          onChange={end => this.setState({ endDate: end })}
                          value={endDate}
                          format="MM-dd-y"
                        />
                      </td>
                      <td><br /><button onClick={this.filterVolumeReport} className="btn btn-info btn-sm">Run</button></td>
                    </tr>
                  </tbody>
                </table>

                <br />
                <div className="card-body">
                  <CSVLink data={volumeitems}>Download CSV of Product Volume</CSVLink>
                  <div className="table-responsive">
                    <ReactTable
                      data={volumeitems}
                      sorted={sortOptions}
                      onSortedChange={val => this.setState({ sortOptions: val })}
                      filterable
                      noDataText='Loading volume report...'
                      columns={[{
                        Header: "Volume Data",
                        columns: [
                          {
                            Header: "Date",
                            accessor: "lg_date",
                            width: 150,
                            Cell: row => <div style={{ textAlign: "center" }}>{moment(row.value).format("MM-DD-YYYY")}</div>
                          },                         
                          {
                            Header: "Total Volume",
                            accessor: "total_volume",
                            width: 150
                          }
                        ]
                      }]}
                      defaultPageSize={50}
                      className="-striped -highlight"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Modal isOpen={modalIsOpen} onRequestClose={this.closeModal} style={customStyles} contentLabel="Client Error">
            <h4>{modalMessage}</h4>
            <button className="btn btn-danger btn-sm" onClick={this.closeModal}>Close</button>
          </Modal>
        </div>
      </div>
    );
  }
}

export default VolumeReport;
